import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setAuthUser } from '../../actions/auth';
import { bindReturnUrl } from '../../utilities/Helper';
import {
  Flex,
  LoadingOverlay,
  PasswordInput,
  Text,
  TextInput
} from '@mantine/core';
import Button from '../../components/elements/Button';
import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { CaptchaContext } from '../../context';

interface LoginFormData {
  username: string;
  password: string;
}

const LoginForm = (props) => {
  const [params, setParams] = useState({
    username: '',
    password: ''
  });

  const { recaptchaRef, tokenReCapv2 } = useContext(CaptchaContext);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<LoginFormData>({
    mode: 'onBlur'
  });

  const fetchLogin = useMutation({
    mutationFn: () => props.setAuthUser(params.username, params.password, ''),
    onSuccess: (data: any) => {
      if (data && data?.userName) {
        setTimeout(() => {
          bindReturnUrl();
        }, 100);
      }
    }
  });

  useEffect(() => {
    if (tokenReCapv2 && params.username && params.password) {
      fetchLogin.mutate();
    }
  }, [tokenReCapv2]);

  const handleSubmitForm = (data: LoginFormData) => {
    setParams(data); // Set params first
    recaptchaRef.current?.execute(); // Trigger reCAPTCHA
  };

  return (
    <>
      <Text c={'dark'} fz={14} fw={600}>
        For Non Binusian
      </Text>
      <form onSubmit={handleSubmit(handleSubmitForm)}>
        <Flex direction={'column'} gap={'sm'}>
          <TextInput
            label='Username/Email'
            placeholder='Input your username or email'
            type='email'
            withAsterisk
            error={errors.username?.message}
            {...register('username', { required: 'Username is required' })}
          />
          <PasswordInput
            label='Password'
            placeholder='Input your password'
            type='password'
            withAsterisk
            error={errors.password?.message}
            {...register('password', { required: 'Password is required' })}
          />
          <Flex mt={16}>
            <Button full type='submit' loading={fetchLogin.isLoading}>
              {' '}
              Login
            </Button>
          </Flex>
        </Flex>
      </form>

      <LoadingOverlay visible={fetchLogin.isLoading} zIndex={99} />
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.userData
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ setAuthUser }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
